import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Steps, Table } from "antd";
import { _adr } from "../../../address";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { NotFound } from "../../../sources/svg/svg";
import { useState } from "react";

import style from "./list.module.scss";
import { convertToJalaliWithoutTime } from "../../../tools/tools";

import Search from "../components/search/search";
import Profile from "../components/profile/profile";
import Address from "../components/address/address";
import Document from "../components/document/document";
import Card from "../components/card/card";
import { FactorCard } from "../components/factor/factor";

const CDList = () => {
	const [t] = useTranslation("global");

	const [creditCard, setCreditCard] = useState({
		step: null,
		profile: {},
		address: {},
		profileId: 0,
		typeSearch: null,
	});

	return (
		<>
			<div className="container-main container-cw">
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("creditCard.title") }]}
						/>
						<div className="title-page">
							<h3>{t("creditCard.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							{creditCard.step == null && <Search setCreditCard={setCreditCard} t={t} style={style} />}
							{creditCard.step != null && (
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={creditCard.step}
											responsive
											items={[
												{
													title: "اطلاعات هویتی ",
												},
												{
													title: "اطلاعات آدرس ",
												},
												{
													title: "آپلود مدارک",
												},
												{
													title: "تخصیص کارت",
												},
											]}
										/>
									</div>
								</div>
							)}
							{creditCard.step == 0 && <Profile creditCard={creditCard} setCreditCard={setCreditCard} t={t} style={style} />}
							{creditCard.step == 1 && <Address creditCard={creditCard} setCreditCard={setCreditCard} t={t} style={style} />}
							{creditCard.step == 2 && <Document creditCard={creditCard} setCreditCard={setCreditCard} t={t} style={style} />}
							{creditCard.step == 3 && <Card creditCard={creditCard} setCreditCard={setCreditCard} t={t} style={style} />}
							{creditCard.step == 4 && <FactorCard creditCard={creditCard} setCreditCard={setCreditCard} t={t} style={style} />}
							{creditCard.step == null && creditCard?.profile && Object.keys(creditCard.profile).length > 0 && (
								<div className="holder-table">
									<Table
										className="tbl-normal"
										columns={[
											{ title: "شماره پاسپورت", dataIndex: "passportNumber", key: "passportNumber", width: 150 },
											{ title: "کدملی", dataIndex: "nationalId", key: "nationalId", width: 150 },
											{ title: "نام", dataIndex: "firstName", key: "firstName", width: 150 },
											{ title: "نام خانوادگی", dataIndex: "lastName", key: "lastName", width: 150 },
											{ title: "تاریخ تولد", dataIndex: "birthdate", key: "birthdate", width: 180 },
											{ title: "شماره موبایل", dataIndex: "mobile", key: "mobile", width: 150 },
											{ title: "", dataIndex: "action", key: "action", width: 150 },
										]}
										scroll={{ y: "100%" }}
										locale={{
											emptyText: <NotFound text={"رکوردی یافت نشد."} />,
										}}
										pagination={false}
										dataSource={[
											(() => {
												const p = creditCard.profile || {};
												const mobile = (p.mobile ?? "").toString().padStart(12, "0");
												return {
													key: "profile-row",
													passportNumber: p.passportNumber,
													nationalId: p.nationalId,
													firstName: p.firstName,
													lastName: p.lastName,
													birthdate: (
														<>
															<span dir="ltr">{String(p.birthdate ?? "")}</span>
															<br />
															{p.birthdate ? convertToJalaliWithoutTime(p.birthdate) : "-"}
														</>
													),
													mobile: <span dir="ltr">{mobile}</span>,
													action: (
														<div style={{ display: "flex", gap: "1rem" }}>
															<Button className="btn-normal" onClick={() => setCreditCard({ ...creditCard, step: 0 })}>
																ویرایش
															</Button>
														</div>
													),
												};
											})(),
										]}
									/>
								</div>
							)}
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CDList;
